import { RouteObject } from "react-router-dom";
import { routes } from "@songtradr-one/shared-common";
import { SignOutForwarder } from "./SignOutForwarder";

// LOADER

// WRAPPER
export const SignOutForwarderWrapper = () => {
  return <SignOutForwarder />;
};

// ROUTE
export const SignOutForwarderRoute: RouteObject[] = [
  {
    path: routes.signout.base,
    Component: SignOutForwarderWrapper,
  },
];
